import Confetti from 'react-confetti';
import { useWindowSize } from 'react-use';

import { useTranslation } from '@lyearn/i18n';
import { Button, Typography } from '@lyearn/ui';
import { Stack } from '@lyearn/ui';
import { Modal } from '@/components/Modals';
import RichTextViewer from '@/components/RichTextViewer';
import { FeatureFlags, useFeatureFlags } from '@/helper/FeatureFlags';

import PointsGoldSVG200 from './PointsGoldSVG200';

const PointsPreviewModal = ({
  points = 0,
  open,
  onClose,
  message,
}: {
  points?: number | null;
  open: boolean;
  onClose: () => void;
  message?: string;
}) => {
  const { t } = useTranslation(['Gamification']);
  const featureFlags = useFeatureFlags();
  const { [FeatureFlags.EnableGamification]: isGamificationEnabled } = featureFlags;

  const { width, height } = useWindowSize();

  if (!isGamificationEnabled) {
    return null;
  }

  return (
    <Modal classes={{ paper: 'h-full' }} open={open} showCloseBtn={false} onClose={onClose}>
      <Confetti gravity={0.2} height={height} width={width} />
      <Stack
        className="h-full"
        direction="col"
        justifyContent="between"
        style={{
          background:
            'linear-gradient(180deg,rgba(255, 232, 118, 0.3) 0%, rgba(255, 255, 255, 1) 60%)',
        }}>
        <Stack alignItems="center" className="p-32 mt-64" direction="col" justifyContent="center">
          <PointsGoldSVG200 />
          {message ? (
            <RichTextViewer className="mt-64" html={message} />
          ) : (
            <Stack
              alignItems="center"
              className="mt-32"
              direction="col"
              gapY={4}
              justifyContent="center">
              <Typography variant="heading-xl">
                {t('Gamification:PointsPreviewTitle', { points })}
              </Typography>
              <Typography className="text-text-secondary text-center" variant="body-short-01">
                {t('Gamification:PointsPreviewDescription', { points })}
              </Typography>
            </Stack>
          )}
        </Stack>
        <Stack direction="col">
          <Stack className="h-[1px] my-[24px] w-full bg-border" />
          <Stack className="mx-16 mb-24">
            <Button fullWidth size="large" onClick={onClose}>
              OK
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </Modal>
  );
};

export default PointsPreviewModal;
